import React, { Fragment } from 'react';
import { Impression, ImpressionContext } from '@nerdwallet/analytics/react/impression';
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import styles from '../../comparison-grid.module.less';
import { getPaginationEntities, getPaginationPayload } from '../compare-grid-pagination-util';
export var CompareGridPaginationDesktop = function CompareGridPaginationDesktop(_ref) {
  var entitiesToCompare = _ref.entitiesToCompare,
      maxEntitiesToShow = _ref.maxEntitiesToShow,
      paginationItemIndex = _ref.paginationItemIndex,
      tabName = _ref.tabName,
      updatePaginationItemIndex = _ref.updatePaginationItemIndex,
      shouldEnableAddEntity = _ref.shouldEnableAddEntity;

  var _getPaginationEntitie = getPaginationEntities({
    paginationItemIndex: paginationItemIndex,
    maxEntitiesToShow: maxEntitiesToShow,
    shouldEnableAddEntity: shouldEnableAddEntity,
    updatePaginationItemIndex: updatePaginationItemIndex,
    totalEntities: entitiesToCompare.length
  }),
      shouldHidePagination = _getPaginationEntitie.shouldHidePagination,
      rightArrow = _getPaginationEntitie.rightArrow,
      leftArrow = _getPaginationEntitie.leftArrow,
      paginationText = _getPaginationEntitie.paginationText;

  var _getPaginationPayload = getPaginationPayload(tabName),
      elementImpressionPayload = _getPaginationPayload.elementImpressionPayload,
      impressionPayload = _getPaginationPayload.impressionPayload;

  return /*#__PURE__*/React.createElement(React.Fragment, null, entitiesToCompare && !shouldHidePagination && /*#__PURE__*/React.createElement(ElementImpression, elementImpressionPayload, /*#__PURE__*/React.createElement(Impression, impressionPayload, /*#__PURE__*/React.createElement(ImpressionContext.Consumer, null, function (impressionContext) {
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles.compareGridPagination
    }, paginationText, leftArrow(impressionContext), rightArrow(impressionContext)));
  }))));
};